var _path, _path2, _rect, _rect2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnsubscribedIcon = function SvgUnsubscribedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5917 13.2183H9.08453H2.60287C2.09251 13.2183 1.8118 12.6059 2.14354 12.2231L3.80224 10.4113C4.05742 10.1306 4.18501 9.77335 4.18501 9.41609V6.68563C4.18501 3.95516 6.50718 1.73507 9.33971 1.86266C11.9936 1.99025 14.0096 4.21035 14.0096 6.81322V9.39057C14.0096 9.74783 14.1372 10.1051 14.3923 10.3858L16.051 12.1976C16.3828 12.6059 16.1021 13.2183 15.5917 13.2183ZM9.08453 15.9998C7.83413 15.9998 6.8134 15.0046 6.8134 13.7797H11.3301C11.3557 15.0046 10.3349 15.9998 9.08453 15.9998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08455 3.70016C8.5997 3.70016 8.19141 3.29187 8.19141 2.80702V0.893142C8.19141 0.408293 8.5997 0 9.08455 0C9.5694 0 9.97769 0.408293 9.97769 0.893142V2.80702C9.97769 3.29187 9.59491 3.70016 9.08455 3.70016Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13.5,
    width: 19,
    height: 2,
    rx: 1,
    transform: "rotate(-30 0 13.5)",
    fill: "#F73B3B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.962402,
    y: 10.9443,
    width: 16.5436,
    height: 2,
    rx: 1,
    transform: "rotate(-30 0.962402 10.9443)",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnsubscribedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unsubscribed-icon.393fdfbe.svg";
export { ForwardRef as ReactComponent };